import { Box, Text, Button } from "@chakra-ui/react"
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import { ChakraProvider } from '@chakra-ui/react';
import DatasetGuest from "./components/DatasetGuest";
import DashboradGuest from "./components/DashboardGuest";
import HomeGuest from "./components/HomeGuest";
import Reindirizzamento from "./Reindirizzamento";
import HeaderGuest from "./components/HeaderGuest.jsx";
import { useEffect } from 'react';
import CookieConsentBanner from "./components/CookieConsentBanner";
import { CookiesProvider } from "react-cookie";
import PortalFirmsPage from "./components/PortalFirmsPage.jsx"
import PortalHouseholdsPage from "./components/PortalHouseholdsPage.jsx"
import PortalInnovationEcosystemPage from "./components/PortalInnovationEcosystemPage.jsx"
import PortalLowCarbonPage from "./components/PortalLowCarbonPage.jsx"
import PortalPublicSectorPage from "./components/PortalPublicSectorPage.jsx"
import PortalSocialSustainabilityPage from "./components/PortalSocialSustainabilityPage.jsx"
import PortalSustainableFinancePage from "./components/PortalSustainableFinancePage.jsx"
import PortalTerritorialSustainabilityPage from "./components/PortalTerritorialSustainabilityPage.jsx"

const GuestApp = () => {

  return (
    <CookiesProvider>
      <ChakraProvider>

        <Box
          height="100vh"
          width="100vw"
          display="flex"
          flexDirection="column"
          overflow="hidden"  // Evita lo scrolling
        >
          <Box width="100%">
            <HeaderGuest />
          </Box>

          <Box
            flex="1"  // Occupa lo spazio rimanente
            display="flex"
            flexDirection="row"
            overflow="hidden"  // Evita lo scrolling all'interno
          >
            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              overflow="hidden"  // Evita lo scrolling all'interno
              id='workarea'
            >
              {/* Area di lavoro */}
              <Routes>

                <Route path="/datasetGuest" element={<DatasetGuest />} />
                <Route path="/dashboardGuest" element={<DashboradGuest />} />
                <Route path="/home" element={<HomeGuest />} />
                <Route path="/" element={<HomeGuest />} />
                <Route path="/guestApp" element={<HomeGuest />} />
                <Route path="/login" element={<Reindirizzamento />} />
                <Route path="/portalFirms" element={< PortalFirmsPage />} />
                <Route path="/portalHouseholds" element={< PortalHouseholdsPage />} />
                <Route path="/portalInnovationEcosystem" element={< PortalInnovationEcosystemPage />} />
                <Route path="/portalLowCarbon" element={< PortalLowCarbonPage />} />
                <Route path="portalPublicSector" element={< PortalPublicSectorPage />} />
                <Route path="/portalSocialSustainability" element={< PortalSocialSustainabilityPage />} />
                <Route path="/portalSustainableFinance" element={< PortalSustainableFinancePage />} />
                <Route path="/portalTerritorialSustainability" element={< PortalTerritorialSustainabilityPage />} />
              </Routes>

            </Box>

          </Box>

          <Box width="100%">

          </Box>

          {/* <div>
           
          <Button
            onClick={() => CookieConsent.showPreferences()}
            data-cc="show-preferencesModal"
          >
            Manage cookie preferences
          </Button>
        </div>*/}
          <CookieConsentBanner />
        </Box>

      </ChakraProvider>
    </CookiesProvider>

  );
}

export default GuestApp;